import { HelperService } from './helper.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class PublicService {
    constructor(private http: HttpClient, private helper: HelperService) {}

    //forgottenPwd() //public access
    public forgottenPwd(data: any): Observable<any> {
        return this.http.post(this.helper.getApiUrl() + '/pwd/forgotten', data);
    }

    public solveUserCaptcha(username: string, guid: string, x: number, y: number): Observable<boolean> {
        return this.http.get(
            this.helper.getRootUrl() + `/captcha/users/${username}/validate/${guid}/${x}/${y}`,
        ) as Observable<boolean>;
    }
}
